// Piece is a run of a message's text, or the place of one of its arguments.
export interface Piece {
  text: string;
  arg: string | null;
}

// pieces splits a message around the arguments a component styles (bold, a
// link), so the markup wraps them while translators still see one sentence.
// write formats the message with each named argument replaced by a marker.
export function pieces(write: (marks: Record<string, string>) => string, names: readonly string[]): Piece[] {
  const marks: Record<string, string> = {};
  for (const n of names) marks[n] = `\u0001${n}\u0001`;
  const out: Piece[] = [];
  const parts = write(marks).split('\u0001');
  for (let i = 0; i < parts.length; i++) {
    if (i % 2 === 1 && names.includes(parts[i])) out.push({ text: '', arg: parts[i] });
    else if (parts[i]) out.push({ text: parts[i], arg: null });
  }
  return out;
}
